import React from 'react'
import PropTypes from 'prop-types'
import KeyboardArrowLeft from 'material-ui/svg-icons/hardware/keyboard-arrow-left'
import KeyboardArrowRight from 'material-ui/svg-icons/hardware/keyboard-arrow-right'
import Today from 'material-ui/svg-icons/action/today'
import { FlatButton } from 'material-ui'

import FilterMenu from '../../sitewide/FilterMenu'
import AllLocationsCheckbox from '../../sitewide/Filter/AllLocationsCheckbox'

import styles from './styles/navbar.css'

const Navbar = ({
  apptTypeDropdown,
  handleAllLocationsCheckbox,
  hasDSO,
  hasPatientPortal,
  locations,
  month,
  multipleLocations,
  onSelectionChange,
  onDateChange,
  searchAllLocations,
  selectedApptType,
  selectedLocationId,
}) => (
  <div className={styles.calendarNavbar}>
    {multipleLocations && (hasDSO ? (
      <div className={styles.allLocationCheckbox}>
        <AllLocationsCheckbox
          checked={searchAllLocations}
          handleCheck={handleAllLocationsCheckbox}
        />
      </div>
    ) : (
      <div className={styles.typeFilter}>
        <FilterMenu
          data={locations}
          labelStyles={styles.labelStyles}
          labelText={'Location'}
          menuItemText={'All Locations'}
          name="selectedLocationId"
          onSelectionChange={onSelectionChange}
          selectStyles={styles.selectStyles}
          value={selectedLocationId}
        />
      </div>
    ))}
    {hasPatientPortal && (
      <div className={styles.typeFilter}>
        <FilterMenu
          data={apptTypeDropdown}
          labelStyles={styles.labelStyles}
          labelText={'Appointment Type'}
          menuItemText={'All Bookings'}
          name="selectedApptType"
          onSelectionChange={onSelectionChange}
          selectStyles={styles.selectStyles}
          value={selectedApptType}
        />
      </div>
    )}
    <div className={styles.dateSelection}>
      <FlatButton
        label="Today"
        icon={<Today />}
        className={styles.today}
        onClick={onDateChange}
      />
      <FlatButton icon={<KeyboardArrowLeft />} onClick={() => onDateChange('prev')} />
      <div className={styles.month}>{month}</div>
      <FlatButton icon={<KeyboardArrowRight />} onClick={() => onDateChange('next')} />
    </div>
  </div>
)

Navbar.propTypes = {
  apptTypeDropdown: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      appointment_type_guid: PropTypes.string,
      practice_id: PropTypes.number,
      code: PropTypes.string,
      description: PropTypes.string,
      visibility: PropTypes.string,
      updated_at: PropTypes.string,
      created_at: PropTypes.string,
      online_scheduling: PropTypes.bool,
    }),
  ),
  handleAllLocationsCheckbox: PropTypes.func.isRequired,
  hasDSO: PropTypes.bool,
  hasPatientPortal: PropTypes.bool,
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool.isRequired,
      additional_recipients: PropTypes.arrayOf(PropTypes.object),
      city: PropTypes.string,
      country_code: PropTypes.string,
      created_at: PropTypes.string,
      doctor_id: PropTypes.string,
      earliest_same_day_reminder_hour: PropTypes.number,
      facebook_url: PropTypes.string,
      forwarding_email: PropTypes.string,
      google_url: PropTypes.string,
      id: PropTypes.string,
      latitude: PropTypes.number,
      longitude: PropTypes.number,
      name: PropTypes.string,
      office_email: PropTypes.string,
      office_phone: PropTypes.string,
      phone_numbers: PropTypes.arrayOf(PropTypes.object),
      practice_id: PropTypes.number,
      state: PropTypes.string,
      street_address: PropTypes.string,
      timezone: PropTypes.string,
      updated_at: PropTypes.string,
      website: PropTypes.string,
      yelp_url: PropTypes.string,
      zip: PropTypes.string,
    }),
  ),
  month: PropTypes.string.isRequired,
  multipleLocations: PropTypes.bool.isRequired,
  onDateChange: PropTypes.func.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  searchAllLocations: PropTypes.bool.isRequired,
  selectedApptType: PropTypes.string,
  selectedLocationId: PropTypes.string,
}

export default Navbar



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/Navbar.js